import { LoginPageContainer } from 'components/loginPage/LoginPageContainer';
import Cookies from 'js-cookie';
import React, { useEffect } from 'react';
import { Header1Text, NavigationItem, BodyText } from 'ui-toolkit';
import { userTypeCookieName } from 'ui-toolkit/authentication/data/userTypeCookieName';
import { ClientUrlFactory } from './ui-toolkit/rest/ClientUrlFactory';
import { eAccessControlLogoutReason } from 'ui-toolkit/enums/eAccessControlLogoutReason';
import { setRedirectTarget } from 'store/authentication/redirectTargetSlice';
import { getDefaultJWTCookie } from './components/accessControl/getSpruceJWTCookie';
import { usePerformSignoutOperation } from 'components/accessControl/hooks/usePerformSignoutOperation';
import { useGetUserType } from 'components/accessControl/hooks/useGetUserType';
import { eAccessControlUserType } from 'ui-toolkit/enums/eAccessControlUserType';
import { useAppDispatch } from './store/store';

const userTypeCookie = Cookies.get(userTypeCookieName) as eAccessControlUserType | undefined;
export const StandaloneLogoutRoute: React.FC = () => {
  const dispatch = useAppDispatch();
  /**
   * Using Query Param so we don't have to change the allowed logout url in auth0
   */
  const searchParams = new URLSearchParams(window.location.search);
  const reason = searchParams.get('reason');
  const lastLocation = searchParams.get('lastLocation');
  lastLocation && dispatch(setRedirectTarget(lastLocation));

  const loggedInUserType = useGetUserType();

  const userType =
    (loggedInUserType !== eAccessControlUserType.None ? loggedInUserType : undefined) ??
    userTypeCookie ??
    eAccessControlUserType.None;

  const [countdown, setCountdown] = React.useState(30);
  const { logout, isReady } = usePerformSignoutOperation(userType);
  const jwt = getDefaultJWTCookie();

  useEffect(() => {
    if (reason === eAccessControlLogoutReason.ADMIN_REDIRECT) {
      window.location.href = ClientUrlFactory().urlFor.spaLogin(eAccessControlUserType.Admin);
    }
    if (jwt && isReady) {
      logout();
    }
  }, [isReady, logout, jwt, reason]);

  useEffect(() => {
    if (countdown !== undefined && reason === eAccessControlLogoutReason.EXPIRED) {
      if (countdown <= 0) {
        window.location.href = ClientUrlFactory().urlFor.spaLogin(
          userTypeCookie || userType || eAccessControlUserType.Admin
        );
      } else {
        setTimeout(() => setCountdown(countdown - 1), 1 * 1000);
      }
    }
  }, [userType, countdown, reason, jwt]);

  return (
    <LoginPageContainer>
      {
        <>
          {reason === eAccessControlLogoutReason.EXPIRED ? (
            <>
              <Header1Text>Your session has expired</Header1Text>
              <BodyText>You will be redirected to login in {countdown}s</BodyText>
            </>
          ) : (
            <Header1Text>You are now logged out</Header1Text>
          )}

          <NavigationItem text="Click here to go to the homepage" href="/"></NavigationItem>
          {userTypeCookie ? (
            <NavigationItem
              text="Click here to log back in"
              to={ClientUrlFactory().urlFor.spaLogin(userTypeCookie)}
            ></NavigationItem>
          ) : (
            <></>
          )}
        </>
      }
    </LoginPageContainer>
  );
};
